import { type ColumnOptions } from "interfaces";

export const columnOptions: ColumnOptions[] = [
  {
    name: "name",
    width: 7,
    isSortable: true,
    className: "group-name-header",
  },
  // NOTE: Add back in once elastic index is updated with members count
  {
    name: "members",
    width: 2,
    isSortable: false,
  },
  {
    name: "Added",
    width: 4,
    isSortable: true,
  },
  {
    name: "",
    width: 1,
  },
];
